import { Injectable } from '@angular/core'
import { UserService } from 'depoto-core/src/services/entities/UserService'
import { TranslateService } from '@ngx-translate/core'
import { CoreService } from '../services'

@Injectable({
  providedIn: 'root',
})
export class MenuService {
  constructor(
    private readonly translateService: TranslateService,
    private readonly core: CoreService,
  ) {}

  menuItems(userService: UserService): MenuItems[] {
    // console.log(userService.roles)
    const isAdmin = userService.hasRole('ROLE_SUPER_ADMIN') || userService.hasRole('ROLE_ADMIN')
    const isDepotoUser =
      userService?.user?.email?.includes('client.depoto.cz') || userService?.user?.email?.includes('tomatom.cz')
    const canViewPurchaseOrders =
      userService.hasRole('CLIENT_MENU_PURCHASE_ORDERS') &&
      this.core.services.user.user.company.moduleRelations?.some(
        moduleRelation => moduleRelation.module.id === 'purchase-orders',
      )
    const menuLinks: MenuItems[] = [
      {
        title: this.translateService.instant('menu.overview'),
        htmlTitle: this.translateService.instant('menu.overview'),
        show: true,
        icon: 'home',
        link: ['/home'],
      },
      {
        title: this.translateService.instant('menu.products'),
        htmlTitle: this.translateService.instant('menu.products'),
        show: isAdmin || userService.hasRole('ROLE_PRODUCT_LIST'),
        icon: 'fad fa-list-alt',
        link: ['/products'],
        action: () => this.core.services.storage.clear(this.core.services.storage.keys.views.productList),
      },
      {
        title: this.translateService.instant('menu.purchase-orders'),
        htmlTitle: this.translateService.instant('menu.purchase-orders'),
        show: isAdmin || canViewPurchaseOrders,
        icon: 'shopping-cart',
        // icon: 'basket-shopping', // todo fa6?
        sublinks: [
          {
            title: this.translateService.instant('menu.purchase-order-list'),
            htmlTitle: this.translateService.instant('menu.purchase-order-list'),
            show: isAdmin || canViewPurchaseOrders,
            icon: 'list',
            link: ['/purchase-orders'],
          },
          {
            title: this.translateService.instant('menu.purchase-orders-on-the-way'),
            htmlTitle: this.translateService.instant('menu.purchase-orders-on-the-way'),
            show: isAdmin || canViewPurchaseOrders,
            icon: 'boxes',
            link: ['/purchase-order-items'],
          },
        ],
      },
      {
        title: this.translateService.instant('menu.receipt-of-goods'),
        htmlTitle: this.translateService.instant('menu.receipt-of-goods'),
        show: isAdmin || userService.hasRole('CLIENT_MENU_IN'),
        icon: 'fad fa-inbox-in',
        link: ['/stock-batch-in'],
      },
      {
        title: this.translateService.instant('menu.stock-batch-out'),
        htmlTitle: this.translateService.instant('menu.stock-batch-out'),
        show: isAdmin || userService.hasRole('CLIENT_MENU_OUT'),
        icon: 'fad fa-inbox-out',
        link: ['/stock-batch-out'],
      },
      {
        title: this.translateService.instant('menu.stock-batch-transfer'),
        htmlTitle: this.translateService.instant('menu.stock-batch-transfer'),
        show: isAdmin || userService.hasRole('CLIENT_MENU_TRANSFER'),
        icon: 'transfer-badge fas fa-exchange-alt',
        link: ['/stock-batch-transfer'],
      },
      {
        title: this.translateService.instant('menu.moves'),
        htmlTitle: this.translateService.instant('menu.moves'),
        show: isAdmin || userService.hasRole('CLIENT_MENU_PRODUCT_MOVES'),
        icon: 'warehouse-alt',
        link: ['/product-move-packs'],
        action: () => this.core.services.storage.clear(this.core.services.storage.keys.views.productMovePackList),
      },
      {
        title: this.translateService.instant('menu.stats'),
        htmlTitle: this.translateService.instant('menu.stats'),
        show: isAdmin || userService.hasRole('CLIENT_MENU_SOLDITEMS'),
        icon: 'chart-pie',
        link: ['/stats'],
      },
      {
        title: this.translateService.instant('menu.inventories'),
        htmlTitle: this.translateService.instant('menu.inventories'),
        show: isAdmin || userService.hasRole('CLIENT_MENU_INVENTORY'),
        icon: 'file-check',
        link: ['/inventory-exports'],
      },
      {
        title: this.translateService.instant('menu.settings'),
        htmlTitle: this.translateService.instant('menu.settings'),
        show: isAdmin || userService.hasRole('CLIENT_MENU_SETTINGS'),
        icon: 'cog',
        sublinks: [
          // todo: Parametry produktů
          {
            title: this.translateService.instant('menu.company'),
            htmlTitle: this.translateService.instant('menu.company'),
            show: isAdmin || userService.hasRole('ROLE_USER_LIST'),
            icon: 'cog',
            link: ['/company'],
          },
          {
            title: this.translateService.instant('menu.users'),
            htmlTitle: this.translateService.instant('menu.users'),
            show: isAdmin || userService.hasRole('ROLE_USER_LIST'),
            icon: 'user',
            link: ['/users'],
          },
          {
            title: this.translateService.instant('menu.categories'),
            htmlTitle: this.translateService.instant('menu.categories'),
            show: isAdmin || userService.hasRole('ROLE_CATEGORY_LIST'),
            icon: 'sitemap',
            link: ['/categories'],
          },
          {
            title: this.translateService.instant('menu.depots'),
            htmlTitle: this.translateService.instant('menu.depots'),
            show: isAdmin || userService.hasRole('ROLE_DEPOT_LIST'),
            icon: 'warehouse',
            link: ['/depots'],
          },
          {
            title: this.translateService.instant('menu.institution'),
            htmlTitle: this.translateService.instant('menu.institution'),
            // todo role
            show: isAdmin || userService.hasRole('CLIENT_MENU_INSTITUTIONS'),
            icon: 'warehouse',
            link: ['/institutions'],
          },
          {
            title: this.translateService.instant('menu.surgery'),
            htmlTitle: this.translateService.instant('menu.surgery'),
            show: isAdmin || userService.hasRole('ROLE_CHECKOUT_LIST'),
            icon: 'warehouse',
            link: ['/surgeries'],
          },
          {
            title: this.translateService.instant('menu.suppliers'),
            htmlTitle: this.translateService.instant('menu.suppliers'),
            show: isAdmin || userService.hasRole('ROLE_SUPPLIER_LIST'),
            icon: 'handshake',
            link: ['/suppliers'],
          },
          {
            title: this.translateService.instant('menu.automatic-orders'),
            htmlTitle: this.translateService.instant('menu.automatic-orders'),
            show: isAdmin || userService.hasRole('ROLE_SUPPLIER_LIST'), // todo role on server
            // show: isAdmin || userService.hasRole('ROLE_AUTOMATIC_ORDERS'), // todo role on server
            icon: 'repeat',
            link: ['/automatic-orders'],
          },
        ],
      },
    ]
    return menuLinks
  }
}
interface MenuItem {
  title: string
  show: boolean
  icon: string
  link?: string[]
  htmlTitle?: string
}

export interface MenuItems {
  title: string
  show: boolean
  icon: string
  link?: string[]
  sublinks?: MenuItem[]
  htmlTitle?: string
  action?: () => any
}
